import script from "./BrandPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandPage.vue?vue&type=script&setup=true&lang=ts"

import "./BrandPage.vue?vue&type=style&index=0&id=532d956c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532d956c"]])

export default __exports__